import repository from '@/store/repository'
import store from '@/store/store'
import cognito from '../cognito'

import router from '@/router/'

export default function (err) {
  // HTTPのエラーでない場合
  if (!err.response) {
    // SignInページへリダイレクトさせる
    const redirectUrl = router.currentRoute.fullPath
    logout()
    router.push(`/sign-in?redirect=${redirectUrl}`)
  }

  // TODO: ステータスコードごとに処理を分ける場合、以下のコードを使う
  // const statusCode = err.response.status | 0

  // SignInページへリダイレクトさせる
  // SignIn後のリダイレクトページを指定する場合
  // const redirectUrl = router.currentRoute.fullPath
  logout()
  router.push('/sign-in')
}

function logout () {
  cognito.logout()
  repository.clearAll()
  store.commit('setUser', null)
  store.commit('setIdToken', null)
  store.commit('setAccessToken', null)
  store.commit('setUserName', null)
  store.commit('setCurrentUnit', null)
  store.commit('setCurrentLesson', null)
  store.commit('setRegistCourseId', null)
}
